import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import SEO from '../../constants/seo';
import Page from '../../components/Page';
import Header from './Header';
import Parallax from './Parallax';
import HappyClient from './HappyClient';
import PerfectTreks from './PerfectTrek';
import { isBrowser } from '../../lib/utils';
import YoutubeSection from './YoutubeSection';
import TravelInsights from './Insights';
import MobileLinkSection from './MobileLinkSection';
import LocalServiceProvider from './LocalServiceProvider';
// import JoinHoneyguideSection from './JoinHoneyguideSection';
import ExtraCTA from './ExtraCTA';
import HgPartners from './HgPartners';
import { openLoginModal, openSignUpModal } from '../../redux/actions/authActions';

if (isBrowser()) {
  require('slick-carousel/slick/slick.css');
  require('slick-carousel/slick/slick-theme.css');
}

type Props = {
  openLoginModal: () => void,
  openSignUpModal: () => void,
  isUserLoggedIn: string,
};

function Landing(props: Props) {
  const { openLoginModal, openSignUpModal, isUserLoggedIn } = props;

  return (
    <Page {...SEO.landing}>
      <Header
        isLoggedIn={isUserLoggedIn}
        onLogin={openLoginModal}
        onSignup={openSignUpModal}
      />
      <Parallax openModal={openSignUpModal} />

      <section className="perfect-trek section section--white">
        <div className="horizontal-scroll">
          <ExtraCTA />
          <HappyClient />
          <TravelInsights />
          <PerfectTreks />

          <div
            className="horizontal-scroll-content horizontal-scroll-content--hexagon-bg direct-connection"
            id="horizontal-scroll-content-3"
          >
            <LocalServiceProvider />
          </div>
        </div>
      </section>

      <Fragment>
        {/* <JoinHoneyguideSection openSignup={openSignUpModal} /> */}
        <YoutubeSection />
        <HgPartners />
        <MobileLinkSection />
      </Fragment>
    </Page>
  );
}

export default connect(
  ({ user }) => ({ isUserLoggedIn: Boolean(user.userId) }),
  {
    openLoginModal,
    openSignUpModal,
  }
)(Landing);



// WEBPACK FOOTER //
// ./src/screens/Landing/Landing.jsx